<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12"><SubHeader title="Admin Search" /></div>
    </div>
  </div>
</template>
<script>
import SubHeader from "@/components/shared/SubHeader.vue";

export default {
  components: { SubHeader },
  data() {
  }
}
</script>
